import * as tslib_1 from "tslib";
import { ElementRef, OnInit, Renderer2 } from '@angular/core';
import { Subject } from 'rxjs';
import { IsInvalidDirective } from 'src/app/modules/core/directives/is-invalid.directive';
export class ModalPlantedTreesComponent {
    constructor(_renderer2, _bsModalService, el, plantingSiteService) {
        this._renderer2 = _renderer2;
        this._bsModalService = _bsModalService;
        this.el = el;
        this.plantingSiteService = plantingSiteService;
        this._onDestroy$ = new Subject();
        this.position = 1;
        this.uploadImageClass = 'upload-file-image';
        this.isInvildSelect = false;
        this.treeSpecies = {};
        this.listSpecies = [];
        this.createNewSpecies = (name) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.creatingNew = true;
            let species = yield this.plantingSiteService.createSpeies(name);
            this.speciesDto.push(species);
            this.creatingNew = false;
            return { id: species.id, species: species.species };
        });
        this.creatingNew = false;
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.isSaved$ = new Subject();
            var isEmpty = Object.keys(this.treeSpecies).length;
            if (isEmpty != 0) {
                this.speciesData = {
                    species: this.treeSpecies.species,
                    id: this.treeSpecies.speciesId,
                };
                this.listSpecies.push(this.speciesData);
                const speciesData = yield this.plantingSiteService.getSpeciesById(this.treeSpecies.speciesId);
                this.description = speciesData.description;
                this.photoUrl = speciesData.photoUrl;
            }
        });
    }
    ngOnDestroy() {
        this._onDestroy$.next();
        this._onDestroy$.complete();
        this.isSaved$.complete();
        const body = document.getElementsByTagName("body")[0];
        this._renderer2.removeClass(body, "modal-open");
    }
    hideNavModal() {
        this._bsModalService.hide();
    }
    save() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.listSpecies.length == 0) {
                this.isInvildSelect = true;
                const ngSelect = document.getElementsByClassName("ng-select-container")[0];
                ngSelect.setAttribute('style', 'border-color: #D22929;');
                return;
            }
            if (this.isInvalidDirectives.some(value => value.isInvalid))
                return;
            this.treeSpecies.speciesId = this.listSpecies[0].id;
            this.treeSpecies.description = this.description;
            const result = yield this.plantingSiteService.saveSpecies(this.treeSpecies, this.plantingSiteAreaId);
            this.treeSpecies.id = result;
            if (this.newPhoto) {
                var resultPhoto = yield this.plantingSiteService.updatePlantedTreesPhoto(this.newPhoto, this.treeSpecies.speciesId);
                this.treeSpecies.photoUrl = resultPhoto.data.originalUrl;
            }
            this.isSaved$.next(true);
            this._bsModalService.hide();
        });
    }
    onPhotoSelected(photo) {
        this.newPhoto = photo;
    }
    //   get max(): number {
    //     if (!this.treeSpecies) { return };
    //     let count = this.treeSpecies.count;
    //     let misc = this.misc;
    //     if (this.isEditPlantedTree) {
    //         return misc === 0 ? count : count + misc;
    //     } else {
    //         return misc;
    //     }
    // }
    onSelect(species) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (species.length != 0) {
                const speciesData = yield this.plantingSiteService.getSpeciesById(species[0].id);
                this.isInvildSelect = false;
                const ngSelect = document.getElementsByClassName("ng-select-container")[0];
                ngSelect.setAttribute('style', '');
                this.photoUrl = speciesData.photoUrl;
                this.description = speciesData.description;
                this.treeSpecies.species = speciesData.species;
            }
            else {
                this.photoUrl = null;
                this.description = "";
                if (this.newPhoto) {
                    this.newPhoto = null;
                }
            }
        });
    }
    trimAndLower(term, species) {
        return !!species.species.toLowerCase().includes(term.toLocaleLowerCase());
    }
}
